import *as _ from 'lodash'
import {ClassificationControlBO} from "./ClassificationControlBO";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {ErrorMessage_restate} from "../PA.Core/Basic/MessageUtils";


export class ClassificationControlBOValidations {

    static async ValidateFields(aBO: ClassificationControlBO): Promise<void> {

        ErrorMessage_restate(aBO.ValidateMessageProvider,
            _.isEmpty(aBO.WB_ClassificationControl.cif.CONTROL_POINT_ID),
            "emptyID", "Control Point Id cannot be empty")

        ErrorMessage_restate(aBO.ValidateMessageProvider,
            _.isEmpty(aBO.WB_ClassificationControl.cif.CONTROL_POINT_NAME),
            "emptyName", "Control Point Name cannot be empty")

        ErrorMessage_restate(aBO.ValidateMessageProvider,
            _.isEmpty(aBO.WB_ClassificationControl.cif.WB_MDSET_ID),
            "emptyField", "Master Data Set cannot be empty")

        ErrorMessage_restate(aBO.ValidateMessageProvider,
            _.isEmpty(aBO.WB_ClassificationControl.cif.ENTERPRISE_POLICY),
            "emptyField", "Enterprise Policy cannot be empty")

        ErrorMessage_restate(aBO.ValidateMessageProvider,
            aBO.WB_ClassificationControl.cif.WB_SALESORG_ID == 0,
            "emptyField", "Sales Org cannot be empty")


        let emptyPartition, emptyProcess, emptySortOrder
        _.forEach(aBO.WB_ClassificationControl.WB_ClassificationControlPartitionRows, aRow=>{
            if(aRow.cif.DELETED_IND !='1'){
                if(aRow.cif.WB_PARTITION_ID == 0 )
                    emptyPartition = true

                if(aRow.cif.WB_CLASSIFICATION_ID == 0 )
                    emptyProcess = true

                if(aRow.cif.SORT_ORDER == 0 )
                    emptySortOrder =true
        }})

        ErrorMessage_restate(aBO.ValidateMessageProvider,
            emptyPartition,
            "emptyPartition", {Title: "Please select Partition for all rows in the grid", Desc:""})

        ErrorMessage_restate(aBO.ValidateMessageProvider,
            emptyProcess,
            "emptyProcess", {Title: "Please select Process for all rows in the grid", Desc:""})

        ErrorMessage_restate(aBO.ValidateMessageProvider,
            emptySortOrder,
            "emptySortOrder", {Title: "Please enter Sort value for all rows in the grid", Desc:""})
    }
}